import React, { useRef, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Stack, TextField, Typography, Card } from '@mui/material';
import Header from '../../core/Header/Header';
import CustomizedSnackbars from '../../shared/Snackbar/SnackBar';
import ButtonMain from '../../components/Button';
import { useDispatch } from 'react-redux';
import { showLoader, hideLoader } from '../../Store/mainSlice';
import httpClient from '../../_util/api';

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const snackbar_Ref = useRef();

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleReset = async () => {
    if (!newPassword || !confirmPassword) {
      return snackbar_Ref.current.showMessage("error", "Please fill all fields", "", "i-chk-circle");
    }

    if (newPassword !== confirmPassword) {
      return snackbar_Ref.current.showMessage("error", "Passwords do not match", "", "i-chk-circle");
    }

    dispatch(showLoader());
    setLoading(true);

    try {
      const res = await httpClient.post(`/user/reset-password/${token}`, { newPassword });
      snackbar_Ref.current.showMessage("success", res?.data?.message || "Password reset successful", "", "i-chk-circle");
    } catch (err) {
      snackbar_Ref.current.showMessage("error", err?.response?.data?.message || "Invalid or expired link", "", "i-chk-circle");
    } finally {
      dispatch(hideLoader());
      setLoading(false);
    }
  };

  return (
    <Stack alignItems="center" justifyContent="center" sx={{ width: '100%', height: '100vh', backgroundColor: '#f5f5f5' }}>
      <Header />
      <CustomizedSnackbars ref={snackbar_Ref} />
      <Card sx={{ width: 350, padding: 4, textAlign: 'center', borderRadius: 3, boxShadow: 3 }}>
        <Typography variant="h5" fontWeight={700} gutterBottom>
          Reset Password
        </Typography>
        <Typography variant="body2" color="textSecondary" mb={2}>
          Enter your new password below.
        </Typography>
        <TextField
          label="New Password"
          type="password"
          variant="outlined"
          fullWidth
          margin="dense"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />
        <TextField
          label="Confirm Password"
          type="password"
          variant="outlined"
          fullWidth
          margin="dense"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
        <ButtonMain
          fullWidth
          sx={{ mt: 2 }}
          onClick={handleReset}
          disabled={loading}
        >
          {loading ? "Resetting..." : "Reset Password"}
        </ButtonMain>
         <ButtonMain
            variant="white"
            fullWidth
            sx={{ mt: 1 }}
            onClick={() => navigate('/')}
        >
            Back to Login
        </ButtonMain>
      </Card>
    </Stack>
  );
};

export default ResetPassword;
